import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Flex from 'legacyfrontend/components/Flex';
import { formatPrice } from 'legacyfrontend/helpers/formatPrice';
import { Typography } from '@mui/material';

const TooltipTotal = ({ price, onlyIcon = false, currency, iconFontSize }) => {
  const priceDetails = [
    { label: 'Base', amount: price.base },
    { label: 'Taxes', amount: price.totalTaxes },
    { label: 'Fee', amount: price.fee },
  ];

  const totalPrice = price.base + price.totalTaxes + price.fee;

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'transparent !important',
          },
        },
      }}
      placement='left'
      title={
        <div className='tooltip-total-container'>
          {priceDetails.map(({ label, amount }, index) => (
            <Flex className='tooltip-total-item' key={index}>
              <Typography className='tooltip-total-label' fontWeight={400}>
                {label}
              </Typography>
              <Typography className='tooltip-total-amount' fontWeight={500}>
                {formatPrice(amount, currency, true)}
              </Typography>
            </Flex>
          ))}
          <div className='tooltip-total-divider' />
          <Flex className='tooltip-total-item tooltip-total-final'>
            <Typography className='tooltip-total-label' fontWeight={600}>
              Total
            </Typography>
            <Typography className='tooltip-total-amount tooltip-total-value' fontWeight={800}>
              {formatPrice(totalPrice, currency, true)}
            </Typography>
          </Flex>
        </div>
      }
    >
      <Box className='flight_card_resume_final_price_container'>
        {!onlyIcon && (
          <Typography className='flight_final_price_alert_text'>Precio Final</Typography>
        )}
        <InfoOutlinedIcon className='tooltip-icon' fontSize={iconFontSize} />
      </Box>
    </Tooltip>
  );
};

export default TooltipTotal;
